import React, { useCallback } from 'react';
import { Switch, Route } from 'react-router-dom';
import routes from '../routes';
import Layout from './Layout';
import AnswerRequest from './AnswerRequest';
import DownloadLinks from './DownloadLinks';
import Support from './Support';
import PrivacyPolicy from './Legal/PrivacyPolicy';
import TermsOfService from './Legal/TermsOfService';
import AuthSetup from './AuthSetup';
import Home from './Home';

export default function App() {
  const renderThankYouRoute = useCallback(props => <DownloadLinks {...props} afterResponse />, []);
  return (
    <Layout>
      <AuthSetup />
      <Switch>
        <Route path={routes.thankYou} render={renderThankYouRoute} />
        <Route path={routes.download} component={DownloadLinks} />
        <Route path={routes.termsOfService} component={TermsOfService} />
        <Route path={routes.privacyPolicy} component={PrivacyPolicy} />
        <Route path={routes.support} component={Support} />
        <Route path={routes.answerRequest.root} component={AnswerRequest} />
        <Route component={Home} />
      </Switch>
    </Layout>
  );
}
